module.exports = __webpack_public_path__ + "img/cmhk.21471d8d.png";